import {
  Box,
  Button,
  ButtonGroup,
  HStack,
  Select,
  Spacer,
  Text,
  VStack,
  useBreakpointValue,
} from '@chakra-ui/react';
import _ from 'lodash';
import { useMemo } from 'react';

export interface PaginationSettings {
  itemCount: number;
  page: number;
  size: number;
  pageCount: number;
  buttonCount?: number;
}
export interface PaginationBarProps extends PaginationSettings {
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
}

export const PaginationBar = (props: PaginationBarProps) => {
  const { itemCount, page, size, pageCount, onPageChange, onPageSizeChange } =
    props;
  const adjustedPage = useMemo(() => page + 1, [page]);
  const handlePageSizeChange = (desiredPageSize: number) => () => {
    if (size === desiredPageSize) return;
    return onPageSizeChange(desiredPageSize);
  };

  const PageButtons = () => (
    <ButtonGroup
      spacing="3"
      justifyContent="space-between"
      width={{ base: 'full', md: 'auto' }}
      variant="secondary"
    >
      {_.range(1, pageCount + 1).map((n, i) => (
        <Button
          key={i}
          isDisabled={adjustedPage === n}
          onClick={() => onPageChange(n)}
        >
          {n}
        </Button>
      ))}
    </ButtonGroup>
  );

  const Dropdown = () => (
    <Select
      placeholder={`Page ${adjustedPage}`}
      maxW="250px"
      onChange={(v) => onPageChange(parseInt(v.target.value))}
    >
      {_.range(1, pageCount + 1).map((n, ind) => (
        <option key={ind} value={n}>
          {n}
        </option>
      ))}
    </Select>
  );

  const DisplayElement = pageCount < 6 ? PageButtons : Dropdown;

  return (
    <Box px={{ base: '4', md: '6' }} pb="5">
      <HStack spacing="3">
        <ButtonGroup
          spacing="3"
          justifyContent="space-between"
          width={{ base: 'full', md: 'auto' }}
          variant="secondary"
        >
          {[20, 40, 60].map((n, i) => (
            <Button
              key={i}
              isDisabled={n === size || itemCount < n}
              onClick={handlePageSizeChange(n)}
            >
              {n}
            </Button>
          ))}
        </ButtonGroup>
        <Spacer />
        <DisplayElement />
        <Spacer />
        <VStack>
          <Text fontSize="xs">{pageCount} page(s)</Text>
          <Text fontSize="xs">{itemCount} item(s)</Text>
        </VStack>
      </HStack>
    </Box>
  );
};
